import React, {useState, useEffect} from 'react'

import {useParams, Link} from 'react-router-dom'
import BatteryComponent from '../components/Battery';
import Button from '../components/Button';
import Pending from '../components/Pending';
import BarChart from '../components/ChartComponent'
import db from '../db.json';
function Battery() {
   
    const {id} = useParams();
    
    //const battery = data && data.filter(bat => bat.id === id)[0]
    const [chartData, setChartData] = useState([])
    const [battery, setBattery] = useState(null)
    
    //create array of array as input for graph coordinates
    const arr = chartData && chartData.map(d => [d.timestamp ? new Date(d.timestamp) : 'N/A',d.stateOfCharge ? d.stateOfCharge : 0])
    useEffect(() => {
        //if the local db.json server is running fetch data from db.json if not 
        //if not from db.json file in src file
        const fetchPrices = async () => {
        //const res = await fetch("https://f2byongc84.execute-api.eu-central-1.amazonaws.com/webdev_test_fetch_batteries?id=" + id)
        try
        {
          const res = await fetch("http://localhost:3003/batteries")
          const data = await res.json()
          const batt = data.filter(ba => ba.id === id)  
          setBattery(batt[0])
          //setChartData(data.measurements)
          setChartData(batt[0].measurements)
        }catch(error)
        {
          const batt = db.batteries.filter(bat => bat.id === id)
          setBattery(batt[0])
          //setChartData(data.measurements)
          setChartData(batt[0].measurements)
        }
      }

    fetchPrices()
  }, [id])

    return (
    
      <div className="App-battery" >
        
        <Link className="App-link" to="/batteries" >
          <Button name='Go back' className='App-battery-btnback'/>
        </Link>
        
       {!battery &&  <Pending  />}
        
        {battery && <>
        <BatteryComponent battery={battery}/>

         <BarChart type="LineChart" headerArr={[[ "Timestamp","StateOfCharge"]]} dataArr={arr}/>
         <BarChart type="ColumnChart" headerArr={[[ "Timestamp","StateOfCharge"]]} dataArr={arr}/>
        </>
      }
      
        
      
    </div>
  )
}

export default Battery